module.exports = __webpack_public_path__ + "img/online-betting-app.6c7409d.svg";